import { makeSceneDoc } from '../kit.js';

/**
 * 河边滩地：有水、有鱼、有别人顺手丢弃的东西。
 * 芦苇丛遮着钓鱼平台，夜里黑熊会过来（看见就绕道）。
 */
export const riversideDoc = makeSceneDoc({
  id: 'riverside',
  name: '河边滩地',
  region: 'suburb',
  tier: 0,
  node: 'riverside',
  desc: '河水不深，滩上有脚印，也有别人不要的桶。',
  w: 36, h: 22,
  fill: ',',
  spawn: { gx: 3, gy: 10 },
  draw(b, rng) {
    b.rect(0, 0, 36, 22, ',');
    b.rect(24, 0, 12, 22, 'w');                    // 河道
    b.rect(21, 0, 3, 22, 'e');                     // 水岸
    b.rect(18, 4, 3, 12, 's');                     // 沙滩
    b.rect(24, 8, 4, 3, 'n');                      // 钓鱼平台（木桥面）
    b.hline(4, 22, 12, 'r');                       // 小路
    b.vline(2, 20, 3, 'r');
    b.scatter('e', 12, { rng, area: [0, 0, 21, 22], only: (c) => c === ',' });
    b.scatter('s', 10, { rng, area: [0, 0, 20, 22], only: (c) => c === ',' });
  },
  props: [
    { type: 'reed_patch', gx: 19, gy: 3 },
    { type: 'reed_patch', gx: 19, gy: 16 },
    { type: 'wild_hazel', gx: 6, gy: 5 },
    { type: 'wild_hazel', gx: 8, gy: 14 },
    { type: 'junk_pile', gx: 12, gy: 7 },
    { type: 'junk_pile', gx: 10, gy: 16 },
    { type: 'oil_drum', gx: 15, gy: 11 },
    { type: 'reed_mat', gx: 26, gy: 8 },
    { type: 'notice_board', gx: 4, gy: 12 },
    { type: 'black_bear', gx: 15, gy: 18 },
  ],
  portals: [
    { to: 'country_road', gx: 3, gy: 21, spawn: [37, 13], label: '回土路' },
  ],
});

export default riversideDoc;
